import { DaniiBTCBannerMoving } from "../../../component/ui/daniibtc-banner-moving";

export default function HeroSection() {
  return (
    <div className="text-[#FFFFFF] ">
      <div className="m-auto h-[677px] w-[500px] max-[600px]:w-[300px]">
        <DaniiBTCBannerMoving />
      </div>
      <div className="flex items-center flex-col text-5xl mt-[-90px] max-[600px]:text-3xl">
        <span className="text-[#7E42FF] font-black">! شـروع کـن</span>
        <h2 className="font-bold p-3">اولین توکن خودتو بساز</h2>
      </div>
    </div>
  );
}
